import { render, staticRenderFns } from "./IconGearGroup.vue?vue&type=template&id=7edce0f2&"
import script from "./IconGearGroup.vue?vue&type=script&lang=js&"
export * from "./IconGearGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports